import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { useCallback, useEffect, useState } from "react";

export const useIsScreenFocused = () => {
    const navigation = useNavigation();
    const [isFocused, setIsFocused] = useState(false);

    useFocusEffect(
        useCallback(() => {
            setIsFocused(true);
        }, []),
    );

    useEffect(() => {
        const unsubscribe = navigation.addListener("blur", () => {
            setIsFocused(false);
        });
        return unsubscribe;
    }, [navigation]);

    return isFocused;
};
